import React from 'react';
import './Team.css'; // Import your CSS file for styling

const Team = () => {
  return (
    <div className="team-container">
      <div className="centered-text">
        <h1>Building Our Team to Better Serve You</h1>
      </div>
    </div>
  );
}

export default Team;
